import React from "react";
import Button from "@material-ui/core/Button";
import { postData } from "../../../api/componentAPIs";
import "./style.scss";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from "./MapPopupStyles.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import MESSAGES  from "../../../appMessages";
import { RMAXLogger } from "../../../services/LoggerService/RMAXLogger";
import { getAnchorPointMarker } from "../../modules/IBPlanning/RoutesView/RouteMap/ShowAnchorPoints/utils";
import { formatTime } from '@dataGrid/gridUtilities';
class AnchorPointPopupInfo extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            droppingAnchorPointInProgress: false
        }
        this.isComponentMounted = false;
    }

    componentDidMount(){
      this.isComponentMounted = true;
    }

    componentWillUnmount(){
      this.isComponentMounted = false;
    }

    dropAnchorPoint = () => {
        const { data } = this.props;
        this.setState({
            droppingAnchorPointInProgress: true
        });
        postData("UpdateRouteAnchorPoint", {
          scenarioId: this.props.scenarioID,
          routeNames: [data.routeName],
          anchorPointName: null
        }).then(
          response => {
            if (response && Math.trunc(response.status/100) === 2) {
                this.props.showNotification(MESSAGES.ANCHORPOINT.DROP_SUCCESS, "success");
                this.props.refreshData();
                if(this.isComponentMounted){
                  this.setState({
                    droppingAnchorPointInProgress: false
                  })
                }
            } else {
              this.handleError(response.status);
            }
          },
          () => {
            this.handleError();
          }
        );

        RMAXLogger.info("AnchorPointDropped", {route:data.routeName});
    }

    handleError = (statusCode) => {
      if(this.isComponentMounted){
        this.setState({
          droppingAnchorPointInProgress: false
        })
      }
      if (statusCode === 403) {
        return;
      }
      this.props.showNotification(MESSAGES.ANCHORPOINT.DROP_FAILURE, "error");
    }

    renderShipperRow = (shipper, weightPercentage) => {
      if (!shipper) return null;    
      const { classes } = this.props;
      return (
        <TableRow className={classes.anchorPointTableRowRoot}>
          <TableCell className={`${classes.dataCell} tableCellValue`}>
            {shipper}
            <span className={classes.boldFont}>{` (${weightPercentage || 0}%)`}</span>
          </TableCell>
        </TableRow>
      );
    };
  

    render(){
      const { classes, theme, isAnchorPointModulePopup, data } = this.props;
    return (
      <Paper className={`${classes.anchorPointRoot} popupBGColor`}>
        <Table className={classes.table} padding="none">
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell className={classes.tableHeadCell}>
                <div className={classes.anchorPointHeader}>
                  <div className={classes.headerIcon}>
                  {getAnchorPointMarker({
                    anchorPointData: {routeAssigned: data.routeAssigned},
                    theme,
                    isActiveAnchorPoint: true,
                    isDisabledAnchorPoint: this.props.isDisabledAnchorPoint,
                    markerColor: this.props.markerColor,
                    markerBorderColor: this.props.markerBorderColor,
                    markerStrokeColor: this.props.markerStrokeColor
                  })}
                  </div>
                  <div className={classes.anchorPointHeaderData}>
                    <div className={classes.anchorPointDetail}>
                      <div>AP: {data.anchorPointName}</div>
                      <span className={classes.emptyTime}>
                        Empty Time: {data.anchorPointEmptyTime}
                      </span>
                    </div>
                    {data.routeAssigned || data.routeName ? (
                      <div className={classes.routeName}>
                        {`Route ${data.routeAssigned || data.routeName}`}
                      </div>
                    ) : null}
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {isAnchorPointModulePopup && Boolean(data.avgPickup) && (
              <TableRow className={classes.anchorPointTableRowRoot}>
                <TableCell className={`${classes.dataCell} tableCellValue`}>
                  {`Avg Pickups: ${data.avgPickup}`}
                </TableCell>
              </TableRow>
            )}
            {isAnchorPointModulePopup && (
              <>
                {this.renderShipperRow(data.shipper1, data.weightPercentageShipper1)}
                {this.renderShipperRow(data.shipper2, data.weightPercentageShipper2)}
              </>
            )}
            {isAnchorPointModulePopup && data.lastDerivedOn && (
              <TableRow className={classes.anchorPointTableRowRoot}>
                <TableCell className={`${classes.dataCell} tableCellValue`}>
                  <span
                    className={
                      classes.italicFont
                    }>{`Last derived on ${data.lastDerivedOn || ""}`}</span>
                </TableCell>
              </TableRow>
            )}
            {!isAnchorPointModulePopup && (
              <TableRow className={classes.anchorPointTableRowRoot}>
              <TableCell className={`${classes.dataCell} tableCellValue`}>
                ETA                
                <span className={classes.startTime}>
                  {formatTime({ value: data.eta })}
                </span> 
                </TableCell>
              </TableRow>
            )}
            {!isAnchorPointModulePopup ? (
                <TableRow className={classes.anchorPointTableRowRoot}>
                  <TableCell className={`${classes.anchorPointBtnCell} ${this.props.disableDrop ? classes.disabled : ""}`} colSpan={2}>
                    <Button
                    className={classes.anchorPointBtn}
                    classes={{disabled: classes.disabledBtn}}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    onClick={this.dropAnchorPoint}
                    disabled={this.props.disableDrop}
                    >
                        {this.state.droppingAnchorPointInProgress ? <CircularProgress  size={16} classes={{root: classes.progress}} />: "Drop Anchor Point"}
                    </Button>
                  </TableCell>
                </TableRow>
              ): null
              }
              </TableBody>
            </Table>
          </Paper>
        )
    }
}
export default withStyles(styles)(AnchorPointPopupInfo);